import UsersPage from './UsersPage';

const UsersDemo = () => {
  return <UsersPage />;
};

export default UsersDemo;
